import PropTypes from 'prop-types'
import React from 'react'
import get from 'lodash-es/get'
import classNames from 'classnames'

import ArrowFilllDownIcon from '../icons/arrowFillDown'
import ArrowFillUpIcon from '../icons/arrowFillUp'

import styles from './pageOffLeftMenu.module.css'

class PageOffLeftMenuItem extends React.Component {
  static propTypes = {
    config: PropTypes.object.isRequired,
    level: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props)
    this.state = { isOpen: false }
  }

  hasChildren() {
    return get(this.props.config, 'children.length')
  }

  onLinkClick(event) {
    if (!this.hasChildren()) {
      return
    }
    event.preventDefault()
    this.setState({ isOpen: !this.state.isOpen })
  }

  render() {
    const { config, level } = this.props
    const { isOpen } = this.state
    const nextLevel = level + 1
    const linkClass = classNames(styles.link, {
      'off-canvas-category-link--empty': level === 1 && !this.hasChildren(),
      'off-canvas-category-link--sub': level > 1 && !this.hasChildren(),
      'off-canvas-category-link': this.hasChildren(),
      'is-open': isOpen
    })
    return (
      <li>
        <a
          href={config.url}
          onClick={this.onLinkClick.bind(this)}
          className={linkClass}
        >
          {config.name + ' '}
          {config.isNew ? (
            <span className="e-text-label -size-s -color-grey-light">
              {' New'}
            </span>
          ) : null}
          {level === 1 && (
            <span className={styles.icon}>
              {isOpen ? <ArrowFillUpIcon /> : <ArrowFilllDownIcon />}
            </span>
          )}
        </a>
        {this.hasChildren() ? (
          <PageOffLeftMenu
            items={config.children}
            level={nextLevel}
            isHidden={!isOpen}
          />
        ) : null}
      </li>
    )
  }
}

const PageOffLeftMenu = ({ items, level = 1, isHidden = false }) => {
  const className = isHidden ? 'fds-u-is-hidden' : ''
  return (
    <ul className={className} data-test-selector="off-canvas-menu">
      {items.map((subConfig, index) => {
        if (subConfig.divider) {
          return <li key={index} className="off-canvas-category-spacer" />
        } else {
          return (
            <PageOffLeftMenuItem key={index} config={subConfig} level={level} />
          )
        }
      })}
    </ul>
  )
}

PageOffLeftMenu.propTypes = {
  items: PropTypes.array.isRequired,
  level: PropTypes.number
}

export default PageOffLeftMenu
